import useApi from "../api";
import { IAuth, ILoginResponse, IPasswords } from "./types";

class AuthService {
  public async login(body: IAuth): Promise<ILoginResponse> {
    return await useApi.post("/auth/login", body);
  }

  public reset(email: string) {
    return useApi.post(`/auth/reset-password?email=${email}`);
  }

  public changePassword(body: {
    oldPassword: string;
    password: string;
    confirmPassword: string;
  }) {
    // swagger: PUT /auth/change-password  (UserChangePasswordDTO)
    return useApi.put(`/auth/change-password`, body);
  }

  // Completes the forgot-password flow: the emailed link carries a JWT with a
  // reset claim; POST /auth/change-password verifies it and sets the password.
  public completeReset(body: IPasswords, token: string): Promise<void> {
    return useApi.post(`/auth/change-password`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // Completes the create-password flow for admin-created users
  // (emailed link /auth/password/create/{token}).
  // Return types are annotated to the unwrapped data shape (the response
  // interceptor returns `response.data`), matching the pattern in user.service.
  public async register(
    body: IPasswords,
    token: string
  ): Promise<ILoginResponse> {
    return await useApi.post(`/auth/register`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  public async refreshToken(token: string): Promise<ILoginResponse> {
    return await useApi.post(
      `/auth/renew`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
}

export default new AuthService();
